import { render, staticRenderFns } from "./PasswordChanger.vue?vue&type=template&id=370c0b2e&"
import script from "./PasswordChanger.vue?vue&type=script&lang=js&"
export * from "./PasswordChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PasswordChanger.vue"
export default component.exports